<template>
    <v-app id="app">
        <bot-header-menu />
        <transition name="fade" mode="out-in">
            <v-main>
                <v-layout fill-height>
                    <bot-snackbar v-model="snackbar" />
                    <router-view class="view"></router-view>
                </v-layout>
            </v-main>
        </transition>
        <bot-footer />
    </v-app>
</template>

<script>
import HeaderMenu from "../components/header/header.menu.vue";
import Footer from "../components/footer/footer.vue";
import BotSnackbar from "../components/bot/snackbar/bot.snackbar.vue";
import { mapState } from "vuex";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            chromeSMS: "chrome/runtime/sendMessage",
            chromeLoadData: "chrome/runtime/loadData",
            chromeRegion: "chrome/region",
            chromeSearch: "chrome/search",
            socketConnect: "socket/connect",
            socketEmit: "socket/emit",
            ahrefsKeywordsJSON: "ahrefs/keywords/loadJSON",
        },
    },
    sms: {
        window_not_found: "Có mở cửa sổ nào đâu mà đóng!",
    },
};
const df = cafe.default;

export default {
    name: "BotTemplate",

    components: {
        "bot-snackbar": BotSnackbar,
        "bot-header-menu": HeaderMenu,
        "bot-footer": Footer,
    },

    // this is state
    data() {
        return {
            isWorking: false,
            windowId: 0,
            socket: {},
        };
    },

    mounted() {
        let { SessionID, LoginRedirect } = this.ua.headers;
        const { setCookie } = this.$options.filters;
        let ck01 = {
            ckName: "client-id",
            ckValue: SessionID,
            isUpdate: false,
        };
        let ck02 = {
            ckName: "login-redirect",
            ckValue: LoginRedirect,
            isUpdate: true,
        };
        setCookie(ck01);
        setCookie(ck02);
    },

    computed: mapState({
        ua: (state) => state.useragent,
        snackbar: (state) => state.views.snackbar,
        chrrt: (state) => state.chrome.runtime,
    }),

    async created() {
        if (process.env.VUE_ENV !== "client") return;
        const dp = this.$store.dispatch;
        let res_sc = await dp(df.sp.socketConnect);
        let text = res_sc.error;
        if (!res_sc || !res_sc.is_success)
            return dp(df.sp.snb, { text, color: "error" });
        let socket = res_sc.data;
        this.socket = socket;
        socket.onAny(async (eventName, req) => {
            console.log(`socket.on.${eventName}`, req);
            const dp = this.$store.dispatch;
            const cm = this.$store.commit;
            let from, sp, port, text, data;
            if (!req.from || !req.from.id) return;
            if (!this.chrrt.from.id || !this.chrrt.from.ip) {
                port = {
                    name: "chrome.runtime.manifest",
                    req: { url: window.location.href },
                };
                let res_manifest = await dp(df.sp.chromeSMS, port);
                text = res_manifest.error;
                if (!res_manifest || !res_manifest.is_success)
                    return dp(df.sp.snb, { text, color: "error" });
                data = res_manifest.data || { tab: {} };
                let tab = data.tab || {};
                let mem = this.ua.member || {};
                let ip = await dp("loadIP");
                from = {
                    source: "id.es6.vn",
                    id: socket.id,
                    extensionId: data.id,
                    windowId: this.chrrt.windowId,
                    ip,
                    isWorking: this.isWorking,
                    name: mem.MemberName || "Anonymous",
                    href: window.location.href,
                    incognito: tab.incognito,
                    browser: this.ua.headers.browser,
                    os: this.ua.headers.os,
                    region: null,
                };
                cm(df.sp.chromeLoadData, { data: { from } });
            }
            let to = [req.from.id];
            let key = eventName.replace("req.", "res.");
            let payload = { is_success: true, data: null };
            from = this.chrrt.from;
            switch (eventName) {
                case "req.poke":
                    payload.data = "How can I help you?";
                    break;
                case "req.region":
                    this.isWorking = true;
                    sp = df.sp.chromeRegion;
                    if (!from.region || !from.region.region || !this.windowId) {
                        payload = await dp(sp);
                        if (payload.is_success)
                            this.windowId = payload.data.windowId;
                    } else {
                        payload.data = from.region;
                    }
                    break;
                case "req.google.search":
                    if (!req.payload) break;
                    this.isWorking = true;
                    sp = df.sp.chromeSearch;
                    payload = await dp(sp, req.payload);
                    break;
                case "req.chrome.windows.remove":
                    if (!this.windowId) {
                        payload = { error: cafe.sms.window_not_found };
                    } else {
                        port = {
                            name: "chrome.windows.remove",
                            req: { windowId: this.windowId },
                        };
                        payload = await dp(df.sp.chromeSMS, port);
                        if (payload.is_success) {
                            this.isWorking = false;
                            this.windowId = 0;
                        }
                    }
                    break;
                default:
                    payload.data = from;
                    break;
            }
            let filter = {
                key,
                to,
                data: { from, payload },
            };
            dp(df.sp.socketEmit, filter);
        });
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.v-input.text-right input {
    text-align: right;
}

.bot-center, .bot-center.v-btn {
    display: block;
    margin: 0 auto;
}

.bot-color-blue {
    color: #005498;
}

.prd-price-vnd, .prdt-price-vnd {
    color: #fd5a23;
    font-weight: bold;
}

.bot-center .v-btn:not(:first-child) {
    margin-left: 10px;
}

.bot-blue {
    color: #298feb;
}

.bot-caption {
    height: 100%;
}

#app {
    width: 100%;
}

.bot-table {
    width: 100%;
    font-size: 16px;
    border: 1px solid gray;
    border-spacing: 2px;
    border-collapse: collapse;
    table-layout: fixed;
    border-radius: 6px;
    border-style: hidden; /* hide standard table (collapsed) border */
    box-shadow: 0 0 0 1px #666; /* this draws the table border */
}

.bot-table tr th, .bot-table tr td {
    padding: 16px;
}

.bot-table tr th {
    text-align: right;
    max-width: 40%;
}

.bot-table tr:not(:last-child) td {
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

fieldset.fieldset-table {
    border-width: 1px;
    padding: 20px;
}

fieldset.fieldset-table:not(:first-child) {
    margin-top: 25px;
}

fieldset.fieldset-table legend {
    padding: 0 12px;
    font-family: 'Roboto-Bold';
}

/* *****|Roboto|***** */
@font-face {
    font-family: 'Roboto-Light';
    font-style: normal;
    src: url('/public/fonts/Roboto/Roboto-Light.ttf');
}

@font-face {
    font-family: 'Roboto-Black';
    font-style: normal;
    src: url('/public/fonts/Roboto/Roboto-Black.ttf');
}

@font-face {
    font-family: 'Roboto-Bold';
    font-style: normal;
    src: url('/public/fonts/Roboto/Roboto-Bold.ttf');
}

@font-face {
    font-family: 'Roboto-Thin';
    font-style: normal;
    src: url('/public/fonts/Roboto/Roboto-Thin.ttf');
}

@font-face {
    font-family: 'Roboto-Regular';
    font-style: normal;
    src: url('/public/fonts/Roboto/Roboto-Regular.ttf');
}
</style>


// WEBPACK FOOTER //
// template.vue